'use client';
import { TrackingEvent } from '@/utils/helpers';
import { analytics } from '@/lib/analytics';
import { Button } from '../Button/Button';
import { PlayIcon as PlayIconLucide } from 'lucide-react';
import { useState } from 'react';
import YouTubeEmbed from '../YouTubeEmbed/YouTubeEmbed';
import { VideoModal } from '../VideoModal/VideoModal';
import { getYoutubeId } from '@/utils/youtube';

export const VideoButton = ({
  url,
  tracking,
  label,
  className = '',
}: {
  url: string;
  tracking?: TrackingEvent;
  label?: string;
  className?: string;
}) => {
  const [open, setOpen] = useState(false);
  const videoId = getYoutubeId(url);
  if (!videoId) return null;
  return (
    <>
      <Button
        onClick={() => {
          if (tracking) {
            analytics.capture(tracking.event, tracking.properties);
          }
          setOpen(true);
        }}
        isSecondary
        className={className}
      >
        <PlayIconLucide className="w-4 h-4" />
        {label && <span>{label}</span>}
      </Button>
      <VideoModal videoId={videoId} open={open} onClose={() => setOpen(false)} />
    </>
  );
};

const VideoCta = ({
  link,
  fullWidth = false,
}: {
  link: string;
  fullWidth?: boolean;
}) => {
  const videoId = getYoutubeId(link);
  if (!videoId) return null;
  return <YouTubeEmbed videoId={videoId} fullWidth={fullWidth} />;
};

export default VideoCta;
